<template>
  <a-modal
    :visible="true"
    title="编辑日程"
    @ok="sub"
    @cancel="cancel"
  >
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="项目">
        <a-input type="text" v-model="editModal.title"></a-input>
      </a-form-item>
      <a-form-item label="贝展时间">
        <a-date-picker v-model="editModal.date" />
        <br />
        <a-time-picker
          v-model="editModal.start_time"
          format="HH:mm"
          :minuteStep="10"
          placeholder="开始时间"
        />
        <span style="margin: 0 5px">-</span>
        <a-time-picker
          v-model="editModal.end_time"
          placeholder="结束时间"
          format="HH:mm"
          :minuteStep="10"
        />
      </a-form-item>
      <a-form-item label="场地">
        <a-input type="text" v-model="editModal.place"></a-input>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="editModal.remarks"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scoped>
</style>

<script>
import moment from "moment";
export default {
  props: ["oldData"],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      editModal: {
        id: null,
        exh_id: null,
        title: "",
        place: "",
        date: null,
        start_time: null,
        end_time: null,
        remarks: "",
      },
    };
  },
  created() {
    this.editModal = { ...this.oldData };

    this.editModal.start_time = moment(
      this.editModal.date + " " + this.editModal.start_time
    );
    this.editModal.end_time = moment(
      this.editModal.date + " " + this.editModal.end_time
    );
    this.editModal.date = moment(this.editModal.date);
    console.log(this.editModal);
  },
  methods: {
    moment,
    async sub() {
      if (!this.editModal.date) return this.$message.error("请选择日期");
      if (!this.editModal.start_time)
        return this.$message.error("请选择开始时间");
      if (!this.editModal.end_time)
        return this.$message.error("请选择结束时间");

      const r = await this.$axios.post("/exh/calendar/edit", this.editModal);
      if (r.status == 1) {
        this.callback(true);
      }
    },
    cancel () {
      console.log(111);
      this.callback(false)
    },
    callback (e) {
      this.$emit('callback', e)
    }
  },
};
</script>